import React from 'react';
import PropTypes from 'prop-types';
import HubSpotForm from '../../../Form/HubSpot/HubSpotForm';

import './ResourceRegistration.scss';

export default class ResourceRegistration extends React.PureComponent {
    render() {
        const { contentElement, formId } = this.props;

        return (
            <div className="component-Employer-Marketing-ResourceRegistration">
                {contentElement}
                <HubSpotForm formId={formId} isHidden={false} />
            </div>
        );
    }
}

ResourceRegistration.propTypes = {
    formId: PropTypes.number.isRequired,
    contentElement: PropTypes.node.isRequired,
};

ResourceRegistration.defaultProps = {};
